import type { ApiError, GameState } from "../worker/lib/types";
import { getInitData } from "./telegram";

export type { ApiError, GameState, GuessRow, GroupEntry, MeStats } from "../worker/lib/types";

export class ApiFailure extends Error {
  constructor(
    public readonly code: ApiError["error"] | "network",
    public readonly status: number,
  ) {
    super(code);
  }
}

async function call<T>(path: string, body?: unknown): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api/wordle${path}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        "x-telegram-init-data": getInitData(),
      },
      body: JSON.stringify(body ?? {}),
    });
  } catch {
    throw new ApiFailure("network", 0);
  }
  if (!res.ok) {
    const err = (await res.json().catch(() => ({ error: "server_error" }))) as ApiError;
    throw new ApiFailure(err.error ?? "server_error", res.status);
  }
  return (await res.json()) as T;
}

export const api = {
  state: () => call<GameState>("/state"),
  guess: (word: string) => call<GameState>("/guess", { word }),
};
